import { Theme } from '@mui/material';

import makeStyles from '@mui/styles/makeStyles';
import createStyles from '@mui/styles/createStyles';

export const useSchoolTileStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: 'flex',
      flexDirection: 'column',
      backgroundColor: theme.customPalette.white,
      color: theme.customPalette.darkBlue,
    },
    svg: {
      '& svg': {
        stroke: theme.customPalette.red,
        '& path': {
          stroke: theme.customPalette.red,
        },
        '& g': {
          stroke: theme.customPalette.red,
        },
      },
    },
    icon: {
      paddingTop: '5px',
    },
  })
);
